import * as types from '@/store/mutation-types';
import Vue from 'vue';

export default {
  [types.setTodoItemProperties](state, update) {
    Object.assign(update.updateTodoItem, update.newTodoItemProperties);
  },
  [types.addTodoItem](state, { newTodoItem }) {
    if (!state.selectedPart || !state.selectedPart._id === newTodoItem.partId) {
      return;
    }
    if (!state.selectedPartTodoItems.find((p) => p._id === newTodoItem._id)) {
      state.selectedPartTodoItems.push(newTodoItem);
    }
  },
  [types.deleteTodoItem](state, { todoItem }) {
    if (!state.selectedPart || !state.selectedPart._id === todoItem.partId) {
      return;
    }
    Vue.set(
      state,
      'selectedPartTodoItems',
      state.selectedPartTodoItems.filter((p) => p._id !== todoItem._id)
    );
  },
  [types.setSelectedPartTodoItems](state, items) {
    Vue.set(state, 'selectedPartTodoItems', items);
  },
};



// WEBPACK FOOTER //
// ./src/store/todoItem/todoItemMutations.js